import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import type {FormattedValue} from 'nutshell-core/types';

import {LeadTwoLine} from '../../../lead/lead-two-line';
import {Link} from '../../../link/link';

import styles from './company-lead.module.css';

export type Lead = {
    leadName: string;
    htmlUrlPath: string;
    htmlUrl: string;
    leadStatus: string;
    avatarUrl: string;
    formattedValue?: FormattedValue;
    relatedPerson?:
        | {
              id: string;
              type: string;
              htmlUrl: string;
              name: string;
          }
        | null
        | undefined;
    relatedCompany?:
        | {
              id: string;
              type: string;
              htmlUrl: string;
              name: string;
          }
        | null
        | undefined;
};

type Props = Lead & {
    onClose: () => void;
};

export function CompanyLead(props: Props) {
    return (
        <div className={styles['detail--full']}>
            <div className={styles['detail-name']}>Lead</div>
            <div className={styles['company-lead']}>
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    to={props.htmlUrlPath}
                    onClick={props.onClose}
                    size='small'
                    preventUnderline={true}
                >
                    <LeadTwoLine
                        avatarUrl={props.avatarUrl}
                        leadName={props.leadName}
                        leadStatus={props.leadStatus}
                        relatedPerson={props.relatedPerson}
                        relatedCompany={props.relatedCompany}
                        formattedValue={props.formattedValue}
                        htmlUrl={props.htmlUrl} // unused - but crashes app if not provided
                        // Hardcoded - we don't want to show the number or link within the lead card
                        leadNumber={null}
                        isLinkable={false}
                    />
                </Link>
            </div>
        </div>
    );
}
